<script setup lang="ts">
import type { JSX } from '@ionic/core'
import { caretDownSharp } from 'ionicons/icons'
import VCIFormItem from '~/components/VCIFormItem.vue'

const modelValue = defineModel<string | number | boolean | undefined>()
const props = defineProps<JSX.IonSelect & {
	isRequired?: boolean
	readonly?: boolean
}>()

// mit Ionic platform auslesen
</script>

<template>
	<VCIFormItem :style="{ 'pointer-events': !!readonly ? 'none' : 'auto' }">
		<VCISelect
			v-model="modelValue"
			v-bind.attr="$attrs"
			v-bind.prop="props"
			justify="start"
			:toggle-icon="caretDownSharp"
		>
			<slot />
		</VCISelect>
		<i
			v-if="!!readonly"
			slot="end"
			class="mdi mdi-lock"
		/>
	</VCIFormItem>
</template>

<style scoped lang="scss">
ion-select::part(label) {
	min-width: 20%;
	font-size: 10px;
}

ion-input {
	&:deep(.label-text-wrapper) {
		min-width: 20%;

		.label-text {
			white-space: normal;
			font-size: 10px
		}
	}
	&:deep(input[type="date"]) {
		display: flex;
	}
}
.error-text {
	font-size: 10px;
	font-weight: normal;
	transform: translateY(-10px);
}
</style>
